import React, { useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import { FaFilter } from "react-icons/fa6";
const CrawlerDataTable = () => {
    const [loading, setLoading] = useState(false);
    const [crawlData, setCrawlData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [hasPrevPage, setHasPrevPage] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [totalDocs, setTotalDocs] = useState(0);



    const [showModal,setShowModal]=useState(false)
   
    const [category,setCategory]=useState("")
    const [categories,setCategories]=useState([])
    const [categoryId,setCategoryId]=useState(null)
    


    const itemsPerPage = 20;

    const getAllCategory = () => {

        apiRequests.get("/api/category/v1/get-all-category")
            .then((res) => {
                setCategories(res.data.data);
             
            })
            .catch(() => { })
         
    };

    useEffect(() => {
        getAllCategory();
    }, []);


  
    const fetchCrawlerData = async (page) => {
        setLoading(true);
        try {
            const res = await apiRequests.get(
                `/api/ads/v1/get-all-ads?page=${page}&limit=${itemsPerPage}&pagination=true`,{params:{category:categoryId}}
            );



            if (Array.isArray(res.data?.data.docs)) {

                setCrawlData(res.data.data.docs);
                setTotalPages(res.data.data.totalPages);
                setCurrentPage(res.data.data.page);
                setHasPrevPage(page > 1);
                setHasNextPage(true);
                setTotalDocs(res.data.data.totalDocs || 0);
            } else {
                setCrawlData([]);
            }
        } catch (err) {

            toast.error("خطا در دریافت داده‌های کرالر");
        } finally {
            setLoading(false);
        }
    };


    function handleEditSubmit(){
        fetchCrawlerData()
        setShowModal(false)
    }

    useEffect(() => {
        fetchCrawlerData(currentPage);
    }, [currentPage]);

    return (
        <div>
            <div className="px-6 py-10 pb-10 text-3xl">
                آگهی های دریافتی ({totalDocs})
            </div>
            <div className="md:flex md:justify-center">

                    <div className="bg-primaryColor-shade6 mt-5 md:mt-5 mx-12 md:mx-0  px-3 md:px-0 py-2 rounded-md flex items-center justify-end md:w-11/12  md:flex-col md:gap-y-4 md:py-4">


                    <div className="flex items-center bg-white rounded-md">
                        

                        <div onClick={()=>{setShowModal(true)}} className="bg-BlueColor-shade5 text-white p-[5px] rounded-md cursor-pointer">
                        <FaFilter></FaFilter>
                        </div>

                    </div>

                    </div>
            </div>


            <div className="flex justify-center mt-8">
                <table className="min-w-[80%] border">
                    <thead className="bg-secondColor-shade4 text-white text-center">
                    <tr>
                        <th className="px-4 py-2">عنوان</th>
                        <th className="px-4 py-2">شماره تماس</th>
                        <th className="px-4 py-2">دسته‌بندی</th>
                        <th className="px-4 py-2">سایت</th>
                        <th className="px-4 py-2">تاریخ</th>
                        <th className="px-4 py-2">لینک</th>
                        <th className="px-4 py-2">شهر</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 text-center">
                    {!loading ? (
                        crawlData.length > 0 ? (
                            crawlData.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-100">
                                    <td className="px-4 py-2">{item?.title || "بدون عنوان"}</td>
                                    <td className="px-4 py-2">{item?.phone || "-"}</td>
                                    <td className="px-4 py-2">{item?.category.Name || "-"}</td>
                                    <td className="px-4 py-2">{item?.site || "-"}</td>
                                    <td className="px-4 py-2">
                                        {item?.createdAt
                                            ? new Date(item.createdAt).toLocaleDateString("fa-IR")
                                            : "-"}
                                    </td>
                                    <td className="px-4 py-2">
                                        <a
                                            href={item?.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:underline"
                                        >
                                            مشاهده
                                        </a>
                                    </td>
                                    <td className="px-4 py-2">
                                        {item?.city?.Name || "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} className="px-4 py-2 text-center">
                                    داده‌ای یافت نشد!
                                </td>
                            </tr>
                        )
                    ) : (
                        <tr>
                            <td colSpan={7} className="px-4 py-2 text-center">
                                در حال بارگیری ...
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {totalPages > 1 && (
                <div className="flex mb-10 justify-center items-center gap-2 mt-4">
                    <button
                        onClick={() => hasPrevPage && setCurrentPage((p) => p - 1)}
                        disabled={!hasPrevPage}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                        قبلی
                    </button>

                    <span>
            صفحه {currentPage} از {totalPages}
          </span>

                    <button
                        onClick={() => hasNextPage && setCurrentPage((p) => p + 1)}
                        disabled={!hasNextPage}
                        className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                        بعدی
                    </button>
                </div>
            )}
                {showModal&& (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
                        <h2 className="text-xl font-bold mb-4 text-center">اعمال فیلتر</h2>
               

                        <div className="mb-4">
                            <label className="block mb-1 font-medium text-gray-700">دسته بندی ها</label>
                            <select
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={categoryId}
                            onChange={(e) => setCategoryId(e.target.value)}
                            >
                                <option>انتخاب کنید</option>
                                {
                                    categories?.map((it,index)=>(
                                        <option value={it._id} key={index}>{it.Name}</option>
                                    ))
                                }
                            </select>
                        </div>

              

                        <div className="flex justify-between">
                            <button
                                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                                onClick={handleEditSubmit}
                            >
                                اعمال فیلتر
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={()=>{setShowModal(false)}}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CrawlerDataTable;

